import { render } from "./InclusiveServices.vue?vue&type=template&id=f340ea54"
import script from "./InclusiveServices.vue?vue&type=script&lang=js"
export * from "./InclusiveServices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__